import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { TableComponent } from '../table/table.component';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-setting-payment-gateway',
  templateUrl: './setting-payment-gateway.component.html',
  styleUrls: ['./setting-payment-gateway.component.scss']
})
export class SettingPaymentGatewayComponent implements AfterViewInit {
  public company_uuid;

  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService, private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
   }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/setting/payment-gateway/get', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Title', type: 'string', key: 'name', filter: 'string'}, 
          {label: 'Sort', type: 'string', key: 'sort', filter: 'string'}, 
          {label: 'Status', type: 'status', key: 'status', filter: 'status'}, 
          {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/setting-payment-gateway/form', hide: true},
          {label: 'Delete', type: 'delete', key: 'uuid', table: 'payment_gateway', title: 'name', hide: true},
        ]}
    this.tb.init(setting);
    this.cdr.detectChanges();
  }

}
